module.exports = "fragment LayoutFragment on Layout {\n  id\n  thumbnail {\n    url\n  }\n}\n"